<template>
    <div>
        <b-row>
            <b-col cols="12">
                <template v-if="isLoading">
                    <span class="icon mr-1">
                        <FontAwesomeIcon icon="spinner" spin/>
                    </span>
                    <span class="label">
                        {{ $t('omt.gui.general.label.loading') }}&hellip;
                    </span>
                </template>

                <template v-else-if="!sleSuggestions.length">
                    Er zijn geen dropship-mogelijkheden voor deze levering.
                </template>

                <template v-else>
                    <b-row class="responsible-location-form mb-3">
                        <b-col cols="5" class="pt-1">
                            Kies een leverancier:
                        </b-col>
                        <b-col cols="7">
                            <b-form-select
                                v-model="dropshipLocationId"
                                :options="dropshipLocationsFormOptions"
                                label="Dropshipper"
                                outlined
                                dense
                                required
                            >
                                <template #first>
                                    <b-form-select-option
                                        :value="null"
                                        disabled
                                    >
                                        {{ $t('omt.gui.general.action.select-one') }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row class="responsible-location-form mb-3">
                        <b-col cols="5">
                            Leverdatum:
                        </b-col>
                        <b-col cols="7">
                            <font-awesome-icon v-if="isLoadingDispatchTypes" icon="spinner" spin/>
                            <span v-else>{{ selectedLocationDeliveryDate | date }}</span>
                        </b-col>
                    </b-row>
                </template>
            </b-col>
        </b-row>
    </div>
</template>

<script>
const DISPATCH_TYPE_DROPSHIP = 'vendor_dropship'

export default {
    name: "ChooseDropshipper",

    props: {
        dispatchRequest: {required: true},
    },

    data: () => ({
        isLoading: true,
        isLoadingDispatchTypes: false,
        dropshipLocationId: null,
        sleSuggestions: [],
        dispatchTypesForLocation: [],
    }),

    mounted() {
        let promises = [
            this.$http.get(`/api/rest/dispatch-requests/id:${this.dispatchRequest.id}/sle-suggestions`, {
                params: {
                    'dispatch-type': 'vendor_dropship',
                },
            })
                .then(response => {
                    this.sleSuggestions = response.data
                })
                .catch(e => {
                    console.error(e)
                    this.$alert("Fout bij het ophalen van de dropshippers", 'danger')
                }),

            this.$store.getters.getAllLocations,
        ]

        Promise.all(promises)
            .then(() => {
                this.isLoading = false
            })
    },

    computed: {
        dropshipLocations() {
            const suggestedDropshipIdentifiers = this.sleSuggestions.map(s => s.shipper_identifier)

            return this.$store.state.allLocations.filter(
                (location) => location.location_type.identifier === "vendor" && suggestedDropshipIdentifiers.indexOf(location.identifier) !== -1
            ).sort((a, b) => a.display_name.localeCompare(b.display_name));
        },
        dropshipLocationsFormOptions() {
            // dropshipLocations, but in the format required by b-form-select (see https://bootstrap-vue.org/docs/components/form-select/)
            return this.dropshipLocations.map((location) => ({
                value: location.id,
                text: `${location.display_name} (${location.identifier})`,
            }));
        },
        selectedLocation() {
            return this.dropshipLocations.find(l => l.id === this.dropshipLocationId)
        },
        selectedLocationDeliveryDate() {
            return this.sleSuggestions.find(s => s.shipper_identifier === this.selectedLocation?.identifier)?.delivery_date
        },
        selectedLocationDispatchType() {
            return this.dispatchTypesForLocation
                .find(d => d.identifier === DISPATCH_TYPE_DROPSHIP)
        },
        selectedLocationDispatchTypeActiveCarrier() {
            return this.selectedLocationDispatchType.carriers
                .find(c => c.carrier_methods.some(m => m.is_active && m.is_active_for_location))
        },
        selectedLocationDispatchTypeActiveCarrierMethod() {
            return this.selectedLocationDispatchTypeActiveCarrier.carrier_methods
                .find(m => m.is_active && m.is_active_for_location)
        },
    },
    methods: {
        handleChange() {
            this.value = this.responsibleLocation;
            this.$emit("dataChange", this.responsibleLocation)
        },
        async getDispatchTypesForLocation() {
            this.isLoadingDispatchTypes = true
            return this.$store.dispatch('loadDispatchInfoForLocation', {type: this.selectedLocation?.location_type?.identifier, identifier: this.selectedLocation?.identifier})
                .then(response => {
                    this.dispatchTypesForLocation = this.$store.getters.getDispatchInfoForLocation(this.selectedLocation?.location_type?.identifier, this.selectedLocation?.identifier)
                        .filter(d => d.is_active && d.is_active_for_location)

                    if (this.dispatchTypesForLocation.length === 0) {
                        this.$alert('Deze locatie heeft geen actieve dispatchtypes', 'danger')
                        return
                    }

                    if (this.dispatchTypesForLocation.length === 1) {
                        this.dispatchType = this.dispatchTypesForLocation[0].identifier
                    }
                })
                .catch(e => {
                    console.error(e)
                    this.$alert('Fout bij het ophalen van de dispatchtypes', 'danger')
                })
                .finally(() => this.isLoadingDispatchTypes = false)
        },
    },

    watch: {
        dropshipLocationId() {
            this.$emit('dataChange')

            this.getDispatchTypesForLocation()
                .then(() => {
                    if (!this.selectedLocationDispatchType) {
                        return
                    }

                    if (!this.selectedLocationDispatchTypeActiveCarrierMethod) {
                        this.$alert(`Deze locatie heeft geen actieve vervoersmethodes voor het dispatchtype '${DISPATCH_TYPE_DROPSHIP}'`)
                        return
                    }

                    this.$emit(
                        'dataChange',
                        this.selectedLocation.location_type.identifier,
                        this.selectedLocation.identifier,
                        this.selectedLocationDispatchType.identifier,
                        this.selectedLocationDispatchTypeActiveCarrier.identifier,
                        this.selectedLocationDispatchTypeActiveCarrierMethod.identifier,
                        this.selectedLocationDeliveryDate,
                    )
                })
        },
    },
};
</script>
